import useSearchParam from '../useSearchParam';
import { initialGroupsSearchFilter } from '../../constants/groups/filter';
import { parseSearchType } from '../../constants/groups/searchType';
import { SearchDateTerms } from '../../types/common/searchfilter';
import { CLOSETGroupsSearchType } from '../../types/api/groups/closet';

export interface CLOSETGroupsInitialSearchParams {
  dateInterval: string[];
  dateTerm: SearchDateTerms | null;
  planTypeValues: number[];
  paymentMethodValues: number[];
  keyword: string;
  searchType: CLOSETGroupsSearchType;
  managerEmail: string | null;
}

export const useCLOSETGroupsInitialSearchParams = (): CLOSETGroupsInitialSearchParams => {
  const searchParams = useSearchParam();

  return {
    dateInterval:
      searchParams.get('dateInterval')?.split(',') || initialGroupsSearchFilter.dateInterval,
    dateTerm:
      Number(searchParams.get('dateTerm')?.split(',')) || initialGroupsSearchFilter.dateTerm,
    planTypeValues:
      searchParams
        .get('planTypeValues')
        ?.split(',')
        ?.map(value => Number(value)) || initialGroupsSearchFilter.planTypeValues,
    paymentMethodValues:
      searchParams
        .get('paymentMethodValues')
        ?.split(',')
        ?.map(value => Number(value)) || initialGroupsSearchFilter.paymentMethodValues,
    keyword: searchParams.get('keyword') || initialGroupsSearchFilter.keyword,
    searchType: parseSearchType(searchParams.get('searchType')),
    managerEmail: searchParams.get('manager'),
  };
};
